import { Phone, Mail, MapPin, Clock, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { COMPANY } from "@/lib/site-data";

export default function Kapcsolat() {
  return (
    <div className="bg-white">
      <section className="relative pt-28 md:pt-36 pb-12 md:pb-16">
        <div className="absolute inset-0 -z-10 bg-gradient-to-b from-[#F8FAFC] to-white" />
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <span className="eyebrow">Kapcsolat</span>
          <h1 className="mt-3 font-heading font-extrabold text-[#0B192C] text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.05] max-w-3xl">
            Vegye fel velünk a kapcsolatot.
          </h1>
          <p className="mt-5 text-gray-600 text-base sm:text-lg leading-relaxed max-w-2xl">
            Szakértő csapatunk készen áll, hogy segítsen Önnek a tökéletes
            ponyva kiválasztásában.
          </p>
        </div>
      </section>

      <section className="pb-16 md:pb-24">
        <div className="max-w-7xl mx-auto px-4 md:px-8 grid lg:grid-cols-12 gap-10">
          <div className="lg:col-span-5 space-y-5">
            <ContactRow
              icon={Phone}
              eyebrow="Telefon"
              title={COMPANY.phone}
              href={`tel:${COMPANY.phoneRaw}`}
              accent
            />
            <ContactRow
              icon={Mail}
              eyebrow="E-mail"
              title={COMPANY.email}
              href={`mailto:${COMPANY.email}`}
            />
            <ContactRow
              icon={MapPin}
              eyebrow="Cím"
              title={COMPANY.address}
            />
            <div className="bg-white p-5 rounded-lg border border-gray-200">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-md bg-[#1E3E62]/5 text-[#1E3E62] flex items-center justify-center">
                  <Clock className="w-5 h-5" />
                </div>
                <div className="text-xs uppercase tracking-widest text-gray-500 font-semibold">
                  Nyitvatartás
                </div>
              </div>
              <ul className="mt-4 divide-y divide-gray-100">
                {COMPANY.hours.map((row) => (
                  <li
                    key={row.d}
                    className="flex items-center justify-between py-2.5 text-sm"
                  >
                    <span className="text-gray-700">{row.d}</span>
                    <span className="font-medium text-[#0B192C]">{row.h}</span>
                  </li>
                ))}
              </ul>
            </div>
            <Button
              asChild
              className="w-full bg-[#EA580C] hover:bg-[#C2410C] h-12 font-semibold"
            >
              <Link to="/#ajanlat">
                Ajánlatkérés űrlapon <ArrowRight className="w-4 h-4" />
              </Link>
            </Button>
          </div>

          <div className="lg:col-span-7">
            <div className="rounded-lg overflow-hidden border border-gray-200 shadow-md aspect-[4/3] md:aspect-auto md:h-full min-h-[420px]">
              <iframe
                title="Fortuna Ponyva Kft. – Dunaharaszti"
                src={COMPANY.mapEmbed}
                width="100%"
                height="100%"
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                style={{ border: 0, minHeight: 420 }}
              />
            </div>
          </div>
        </div>
      </section>

      {/* Why us strip */}
      <section className="bg-[#F8FAFC] py-14 md:py-20">
        <div className="max-w-5xl mx-auto px-4 md:px-8">
          <span className="eyebrow">Miért válasszon minket?</span>
          <ul className="mt-6 grid sm:grid-cols-2 gap-x-8 gap-y-3 text-gray-700 text-base">
            <li>· Kiváló minőségű alapanyagok és kivitelezés</li>
            <li>· {COMPANY.experienceYears}+ év szakmai tapasztalat</li>
            <li>· Egyedi, személyre szabott megoldások</li>
            <li>· Gyors és pontos kivitelezés</li>
            <li>· Versenyképes árak, kedvező feltételek</li>
            <li>· Munkáinkra garanciát vállalunk, valós határidők</li>
          </ul>
        </div>
      </section>
    </div>
  );
}

const ContactRow = ({ icon: Icon, eyebrow, title, href, accent }) => {
  const content = (
    <>
      <div
        className={`w-10 h-10 rounded-md flex items-center justify-center shrink-0 ${
          accent
            ? "bg-[#EA580C] text-white"
            : "bg-[#1E3E62]/5 text-[#1E3E62]"
        }`}
      >
        <Icon className="w-5 h-5" />
      </div>
      <div>
        <div className="text-xs uppercase tracking-widest text-gray-500 font-semibold">
          {eyebrow}
        </div>
        <div className="mt-0.5 font-heading font-bold text-[#0B192C] text-lg">
          {title}
        </div>
      </div>
    </>
  );
  return href ? (
    <a
      href={href}
      className="bg-white p-5 rounded-lg border border-gray-200 hover:border-[#EA580C] hover:shadow-md transition-all flex items-center gap-4 group"
    >
      {content}
    </a>
  ) : (
    <div className="bg-white p-5 rounded-lg border border-gray-200 flex items-center gap-4">
      {content}
    </div>
  );
};
